// import { ADD_UPDATE_TEMPLATE, ADD_UPDATE_TEMPLATE_SUCCESS, GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES, GET_ALL_PUBLIC_TEMPLATES, GET_TEMPLATES, GET_TEMPLATES_SUCCESS } from '../../../constants/ActionTypes';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';
export const DELETE_TEMPLATE_ERROR = 'DELETE_TEMPLATE_ERROR';
export const GET_ALL_GROUP_TEMPLATES = 'GET_ALL_GROUP_TEMPLATES';
export const GET_ALL_GROUP_TEMPLATES_SUCCESS = 'GET_ALL_GROUP_TEMPLATES_SUCCESS';
export const GET_ALL_GROUP_TEMPLATES_ERROR = 'GET_ALL_GROUP_TEMPLATES_ERROR';
export const ADD_UPDATE_GROUP_TEMPLATE = "ADD_UPDATE_GROUP_TEMPLATE";
export const ADD_UPDATE_GROUP_TEMPLATE_ERROR = "ADD_UPDATE_GROUP_TEMPLATE_ERROR";
export const ADD_UPDATE_GROUP_TEMPLATE_SUCCESS = "ADD_UPDATE_GROUP_TEMPLATE_SUCCESS";

export const GET_ALL_CATEGORIZED_GROUP_TEMPLATES = 'GET_ALL_CATEGORIZED_GROUP_TEMPLATES';
export const GET_ALL_CATEGORIZED_GROUP_TEMPLATES_SUCCESS = 'GET_ALL_CATEGORIZED_GROUP_TEMPLATES_SUCCESS';
export const GET_ALL_CATEGORIZED_GROUP_TEMPLATES_ERROR = 'GET_ALL_CATEGORIZED_GROUP_TEMPLATES_ERROR';
export const DELETE_GROUP_TEMPLATE = "DELETE_GROUP_TEMPLATE";
export const DELETE_GROUP_TEMPLATE_SUCCESS = "DELETE_GROUP_TEMPLATE_SUCCESS";
export const DELETE_GROUP_TEMPLATE_ERROR = "DELETE_GROUP_TEMPLATE_ERROR";

export const ADD_UPDATE_TEMPLATE = "ADD_UPDATE_TEMPLATE";
export const ADD_UPDATE_TEMPLATE_SUCCESS = "ADD_UPDATE_TEMPLATE_SUCCESS";
export const ADD_UPDATE_TEMPLATE_ERROR = "ADD_UPDATE_TEMPLATE_ERROR";

export const GET_ALL_PUBLIC_TEMPLATES = "GET_ALL_PUBLIC_TEMPLATES";
export const GET_ALL_PUBLIC_TEMPLATES_ERROR = "GET_ALL_PUBLIC_TEMPLATES_ERROR";
export const GET_ALL_PUBLIC_TEMPLATES_SUCCESS = "GET_ALL_PUBLIC_TEMPLATES_SUCCESS";

export const GET_TEMPLATES = "GET_TEMPLATES";
export const GET_TEMPLATES_SUCCESS = "GET_TEMPLATES_SUCCESS";

export const GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES = "GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES";
export const GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_ERROR = "GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_ERROR";
export const GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_SUCCESS = "GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_SUCCESS";



export const SHOW_TEMPLATES_MESSAGE = "SHOW_TEMPLATES_MESSAGE";



export const getTemplates = (userId) => {
    return {
        type: GET_TEMPLATES,
        payload: { userId }
    };
};

export const getTemplatesSuccess = (templates) => {
    return {
        type: GET_TEMPLATES_SUCCESS,
        templates: templates
    };
};

export const addUpdateTemplate = (template) => {
    return {
        type: ADD_UPDATE_TEMPLATE,
        payload: { template }
    }
}

export const addUpdateTemplateSuccess = (template) => {
    return {
        type: ADD_UPDATE_TEMPLATE_SUCCESS,
        template: template
    };
};
export const getAllPublicTemplates = () => {
    return {
        type: GET_ALL_PUBLIC_TEMPLATES,
        payload: null
    };
};

export const getAllCategorizedPublicTemplates = () => {
    return {
        type: GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES,
        payload: null
    };
};

export const deletePrivateTemplate = (template) => {
    return {
        type: DELETE_TEMPLATE,
        payload: { template }
    };
};

export const getAllGroupTemplates = () => {
    return {
        type: GET_ALL_GROUP_TEMPLATES
    };
};

export const addUpdateGroupTemplate = (template) => {
    return {
        type: ADD_UPDATE_GROUP_TEMPLATE,
        template
    }
}

export const addUpdateGroupTemplateSuccess = (groupTemplate) => {
    return {
        type: ADD_UPDATE_GROUP_TEMPLATE_SUCCESS,
        groupTemplate
    };
};

export const getAllCategorizedGroupTemplates = () => {
    return {
        type: GET_ALL_CATEGORIZED_GROUP_TEMPLATES,
    };
};

export const deleteGroupTemplate = (template) => {
    return {
        type: DELETE_GROUP_TEMPLATE,
        payload: { template }
    };
};